import Logger from '../util/Logger';
import _ from 'lodash';

export default {

  /**
   * Get the id
   * @param comment
   * @returns {string} Comment id
   */
  getId (comment) {
    if (!comment) {
      Logger.assert('Must pass a comment object');
    } else {
      const id = _.get(comment, 'id');
      if (!id) {
        Logger.assert('Idea was missing id');
      } else {
        return id;
      }
    }
  },

  /**
   * Can this comment be deleted?
   * @param comment
   * @returns {boolean} Can be deleted
   */
  canDelete (comment) {
    if (!comment) {
      Logger.assert('Must pass an comment object');
    } else {
      return _.get(comment, 'can_delete') || false;
    }
  },

    /**
   * Can this comment be archived?
   * @param comment
   * @returns {boolean} Can be archived
   */
  canArchive (comment) {
    if (!comment) {
      Logger.assert('Must pass an comment object');
    } else {
      return _.get(comment, 'can_archive') || false;
    }
  }

};
